
  .responsive3208187990__root .ControlBase1631115975__root.ControlBase1631115975---alignment-15-vertical-narrow.ControlBase1631115975--hasHeader,
  .responsive3208187990__root .ControlBase1631115975__root.ControlBase1631115975---alignment-8-vertical,
  .responsive3208187990__root .ControlBase1631115975__root.ControlBase1631115975---alignment-10-horizontal {
    gap: 8px;
  }

  .responsive3208187990__root .ControlBase1631115975__root.ControlBase1631115975---alignment-8-vertical.ControlBase1631115975--hasHeader,
  .responsive3208187990__root .ControlBase1631115975__root.ControlBase1631115975---alignment-15-vertical-narrow.ControlBase1631115975--hasHeader {
    padding: 8px 24px 12px;
  }

  .responsive3208187990__root .ControlBase1631115975__root.ControlBase1631115975---alignment-8-vertical:not(hasHeader) {
    padding: 12px 24px;
  }

  .responsive3208187990__root .ControlBase1631115975__divider {
    background: #e5e5e5;
  }

/* st-namespace-reference="../../../../src/controls/ControlBase/ControlBase.responsive.st.css" */